/**
 * Cart Size Grid v17
 * Pure event binding and AJAX updates (SSR rendered markup)
 */
(function() {
  'use strict';

  console.log('[SizeGrid] v17 loaded');

  var saveTimers = {};

  function fetchCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function findMatchingCartItem(allItems, variantId, custId) {
    for (var i = 0; i < allItems.length; i++) {
      var ci = allItems[i];
      if (ci.variant_id !== variantId) continue;
      if (!custId) return ci;
      var ciCustId = ci.properties ? (ci.properties.customizationId || ci.properties._customizationId || '') : '';
      if (ciCustId === custId) return ci;
    }
    return null;
  }

  // ---- AUTO-SAVE for size grid ----
  function autoSaveSizeGrid(gridEl) {
    var gridId = gridEl.dataset.variantId || 'grid';
    clearTimeout(saveTimers[gridId]);
    saveTimers[gridId] = setTimeout(function() {
      doSaveSizeGrid(gridEl);
    }, 800);
  }

  async function doSaveSizeGrid(gridEl) {
    var itemsContainer = gridEl.querySelector('.size-grid__items');
    if (!itemsContainer) return;

    var properties = {};
    try { properties = JSON.parse(itemsContainer.dataset.properties || '{}'); } catch(e) {}

    var items = gridEl.querySelectorAll('.size-grid__item');
    var cart = await fetchCart();
    var custId = properties.customizationId || properties._customizationId || '';
    var requests = [];

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var variantId = parseInt(item.dataset.variantId);
      var cloneVariantId = item.dataset.cloneVariantId ? parseInt(item.dataset.cloneVariantId) : null;
      var newQty = parseInt(item.querySelector('.size-grid__qty-input').value) || 0;
      var origQty = parseInt(item.dataset.originalQty) || 0;

      if (newQty === origQty) continue;

      var targetVariantId = cloneVariantId || variantId;
      var existing = findMatchingCartItem(cart.items, targetVariantId, custId);

      if (existing) {
        requests.push({ type: 'change', id: existing.key, quantity: newQty });
      } else if (newQty > 0) {
        requests.push({ type: 'add', id: targetVariantId, quantity: newQty, properties: properties });
      }
    }

    if (requests.length === 0) return;

    console.log('[SizeGrid] Auto-saving', requests.length, 'changes');

    for (var j = 0; j < requests.length; j++) {
      var req = requests[j];
      if (req.type === 'change') {
        await fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: req.id, quantity: req.quantity })
        });
      } else {
        await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: req.id, quantity: req.quantity, properties: req.properties }] })
        });
      }
    }

    window.location.reload();
  }

  // ---- AUTO-SAVE for simple qty ----
  function autoSaveSimpleQty(gridEl) {
    clearTimeout(gridEl._saveTimer);
    gridEl._saveTimer = setTimeout(function() {
      var input = gridEl.querySelector('.size-grid__simple-input');
      if (!input) return;
      var lineKey = input.dataset.lineKey;
      var newQty = parseInt(input.value) || 1;
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: newQty })
      }).then(function() { window.location.reload(); });
    }, 800);
  }

  // ---- ATTACH EVENTS ----
  function attachEvents(gridEl, isSimple) {
    gridEl.querySelectorAll('.size-grid__minus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var itemEl = btn.closest('.size-grid__item') || gridEl;
        itemEl.classList.add('is-updating');
        
        var input = btn.parentElement.querySelector('.size-grid__qty-input');
        var minVal = isSimple ? 1 : 0;
        var val = Math.max(minVal, parseInt(input.value) - 1);
        input.value = val;
        btn.disabled = val <= minVal;
        if (isSimple) autoSaveSimpleQty(gridEl);
        else autoSaveSizeGrid(gridEl);
      });
    });

    gridEl.querySelectorAll('.size-grid__plus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var itemEl = btn.closest('.size-grid__item') || gridEl;
        itemEl.classList.add('is-updating');

        var input = btn.parentElement.querySelector('.size-grid__qty-input');
        input.value = parseInt(input.value) + 1;
        var minus = btn.parentElement.querySelector('.size-grid__minus');
        if (minus) minus.disabled = false;
        if (isSimple) autoSaveSimpleQty(gridEl);
        else autoSaveSizeGrid(gridEl);
      });
    });

    gridEl.querySelectorAll('.size-grid__qty-input').forEach(function(input) {
      input.addEventListener('change', function() {
        var itemEl = input.closest('.size-grid__item') || gridEl;
        itemEl.classList.add('is-updating');

        var minVal = isSimple ? 1 : 0;
        input.value = Math.max(minVal, parseInt(input.value) || minVal);
        var minus = input.parentElement.querySelector('.size-grid__minus');
        if (minus) minus.disabled = parseInt(input.value) <= minVal;
        if (isSimple) autoSaveSimpleQty(gridEl);
        else autoSaveSizeGrid(gridEl);
      });
    });
  }

  async function initFpdDynamicGrids() {
    var grids = document.querySelectorAll('.fpd-dynamic-grid:not([data-loaded])');
    if (!grids.length) return;

    var cart = await fetchCart();

    for (var i = 0; i < grids.length; i++) {
      var gridEl = grids[i];
      gridEl.setAttribute('data-loaded', 'true');
      loadDynamicGrid(gridEl, cart);
    }
  }

  async function loadDynamicGrid(gridEl, cart) {
    try {
      var originalProductId = gridEl.dataset.originalProductId;
      var cloneVariantId = parseInt(gridEl.dataset.cloneVariantId);
      var cloneLineKey = gridEl.dataset.lineKey;
      var properties = JSON.parse(gridEl.dataset.properties || '{}');
      var cloneOptions = JSON.parse(gridEl.dataset.cloneOptions || '[]');
      var custId = properties.customizationId || properties._customizationId || '';

      // 1. Fetch handle from suggestion API
      var suggestRes = await fetch('/search/suggest.json?q=id:' + originalProductId + '&resources[type]=product').then(r => r.json());
      var products = suggestRes.resources && suggestRes.resources.results && suggestRes.resources.results.products;
      if (!products || !products.length) {
        gridEl.innerHTML = '<div class="size-grid__error" style="font-size: 13px; color: #d93838; margin-top: 10px;">Feil under lasting av størrelser (originalt produkt ble ikke funnet)</div>';
        return;
      }
      var handle = products[0].handle;

      // 2. Fetch full product JSON
      var product = await fetch('/products/' + handle + '.js').then(r => r.json());

      // 3. Find size option index
      var sizeOptionIndex = -1;
      for (var k = 0; k < product.options.length; k++) {
        var optName = product.options[k].name.toLowerCase();
        if (optName.includes('size') || optName.includes('størrelse') || optName.includes('storlek') || optName.includes('größe') || optName.includes('taille')) {
          sizeOptionIndex = k;
          break;
        }
      }

      if (sizeOptionIndex === -1) {
        gridEl.innerHTML = ''; // No sizes for this product
        return;
      }

      // 4. Match variants that have same other options (e.g. Color)
      var matchingVariants = [];
      for (var v = 0; v < product.variants.length; v++) {
        var variant = product.variants[v];
        var isMatch = true;
        
        if (sizeOptionIndex !== 0 && cloneOptions[0] && variant.option1 !== cloneOptions[0]) {
          isMatch = false;
        }
        if (sizeOptionIndex !== 1 && cloneOptions[1] && variant.option2 !== cloneOptions[1]) {
          isMatch = false;
        }
        if (sizeOptionIndex !== 2 && cloneOptions[2] && variant.option3 !== cloneOptions[2]) {
          isMatch = false;
        }

        if (isMatch) {
          matchingVariants.push(variant);
        }
      }

      if (matchingVariants.length <= 1) {
        gridEl.innerHTML = ''; // Not enough size variants
        return;
      }

      // 5. Build HTML
      var labelSizes = window.Shopify && (window.Shopify.locale === 'nb' || window.Shopify.locale === 'no') ? 'Størrelser:' : 'Sizes:';
      
      var html = '<div class="size-grid__label">' + labelSizes + '</div>';
      html += '<div class="size-grid__items" data-properties=\'' + JSON.stringify(properties) + '\'>';

      for (var m = 0; m < matchingVariants.length; m++) {
        var variant = matchingVariants[m];
        var sizeVal = variant.options[sizeOptionIndex];
        
        var vQty = 0;
        for (var c = 0; c < cart.items.length; c++) {
          var cartItem = cart.items[c];
          var cartItemCustId = cartItem.properties ? (cartItem.properties.customizationId || cartItem.properties._customizationId || '') : '';
          
          if (cartItemCustId === custId) {
            var cartItemMatches = false;
            if (cartItem.variant_id === cloneVariantId) {
              var cloneMatchesVariant = true;
              if (variant.option1 !== cloneOptions[0]) cloneMatchesVariant = false;
              if (variant.option2 !== cloneOptions[1]) cloneMatchesVariant = false;
              if (variant.option3 !== cloneOptions[2]) cloneMatchesVariant = false;
              if (cloneMatchesVariant) {
                cartItemMatches = true;
              }
            } else if (cartItem.variant_id === variant.id) {
              cartItemMatches = true;
            }

            if (cartItemMatches) {
              vQty += cartItem.quantity;
            }
          }
        }

        var isCurrent = false;
        var cloneMatchesCurrent = true;
        if (variant.option1 !== cloneOptions[0]) cloneMatchesCurrent = false;
        if (variant.option2 !== cloneOptions[1]) cloneMatchesCurrent = false;
        if (variant.option3 !== cloneOptions[2]) cloneMatchesCurrent = false;
        if (cloneMatchesCurrent) {
          isCurrent = true;
        }

        var formattedPrice = (variant.price / 100).toFixed(2).replace('.', ',') + ' NOK';

        html += '<div class="size-grid__item' + (isCurrent ? ' size-grid__item--current' : '') + '"';
        html += '     data-variant-id="' + variant.id + '"';
        if (isCurrent) {
          html += '   data-clone-variant-id="' + cloneVariantId + '"';
          html += '   data-clone-line-key="' + cloneLineKey + '"';
        }
        html += '     data-price="' + variant.price + '"';
        html += '     data-original-qty="' + vQty + '">';
        html += '  <span class="size-grid__size-label">' + sizeVal + '</span>';
        html += '  <div class="size-grid__qty-controls">';
        html += '    <button type="button" class="size-grid__minus"' + (vQty <= 0 ? ' disabled' : '') + '>−</button>';
        html += '    <input type="number" class="size-grid__qty-input" value="' + vQty + '" min="0" max="99">';
        html += '    <button type="button" class="size-grid__plus">+</button>';
        html += '  </div>';
        html += '  <span class="size-grid__item-price">' + formattedPrice + '</span>';
        html += '</div>';
      }

      html += '</div>';
      gridEl.innerHTML = html;
      gridEl.setAttribute('data-initialized', 'true');

      attachEvents(gridEl, false);

    } catch (err) {
      console.error('[SizeGrid] Failed to load dynamic grid:', err);
      gridEl.innerHTML = '<div class="size-grid__error" style="font-size: 13px; color: #d93838; margin-top: 10px;">Kunne ikke laste størrelser</div>';
    }
  }

  function preventFpdDuplicates() {
    var mediaContainers = document.querySelectorAll('.cart-items__media, .cart-item__media');
    mediaContainers.forEach(function(container) {
      var link = container.querySelector('.cart-items__media-container');
      var linkImg = link ? link.querySelector('img') : null;
      var directImg = null;
      for (var i = 0; i < container.children.length; i++) {
        if (container.children[i].tagName === 'IMG') {
          directImg = container.children[i];
          break;
        }
      }
      if (link && linkImg && directImg) {
        if (linkImg.src !== directImg.src) {
          linkImg.removeAttribute('srcset');
          linkImg.removeAttribute('data-srcset');
          linkImg.src = directImg.src;
        }
        linkImg.style.setProperty('display', 'block', 'important');
        directImg.style.setProperty('display', 'none', 'important');
      }
    });
  }

  // ---- INIT ----
  function init() {
    initFpdDynamicGrids();
    preventFpdDuplicates();

    var grids = document.querySelectorAll('.cart-size-grid:not([data-initialized])');
    if (!grids.length) return;

    console.log('[SizeGrid] Attaching events to', grids.length, 'grid(s)');

    for (var i = 0; i < grids.length; i++) {
      var gridEl = grids[i];
      gridEl.setAttribute('data-initialized', 'true');

      var isSimple = gridEl.querySelector('.size-grid__simple-qty') !== null;
      attachEvents(gridEl, isSimple);
    }
  }

  // ---- RE-INIT on DOM changes (e.g. after item removal) ----
  function observeCartUpdates() {
    var cartContainer = document.querySelector('.cart-items-component, .cart-items__wrapper, #cart-form');
    var target = cartContainer || document.body;

    var observer = new MutationObserver(function(mutations) {
      preventFpdDuplicates();
      var hasNew = document.querySelector('.cart-size-grid:not([data-initialized]), .fpd-dynamic-grid:not([data-loaded])');
      if (hasNew) {
        console.log('[SizeGrid] New grids detected after DOM update, re-binding events...');
        init();
      }
    });

    observer.observe(target, { childList: true, subtree: true });
    console.log('[SizeGrid] MutationObserver attached to', target.tagName || 'body');
  }

  // Run on interval to catch late FPD injections
  var duplicateTimer = setInterval(preventFpdDuplicates, 150);
  setTimeout(function() { clearInterval(duplicateTimer); }, 5000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
      observeCartUpdates();
      preventFpdDuplicates();
    });
  } else {
    init();
    observeCartUpdates();
    preventFpdDuplicates();
  }
})();
